import { cocktailConstants } from '../_constants';
import { connect } from 'react-redux';
import { cocktailActions } from '../_actions';


export function recipe_image(state = {}, action) {
  switch (action.type) {

  case cocktailConstants.GETRECIPEIMAGEBYID_REQUEST:
    return {
      loading: true
    };
  case cocktailConstants.GETRECIPEIMAGEBYID_SUCCESS:
    return {
      image: {[action._id]: action.recipe_image}
    };
  case cocktailConstants.GETRECIPEIMAGEBYID_FAILURE:
    return {
      error: action.error
    };
  default:
    return state
  }
}


// WEBPACK FOOTER //
// ./src/_reducers/recipe_image.reducer.js